// import node_modules
import * as PropTypes from 'prop-types';
import * as React from 'react';

// import types
import type { GetStaticProps, NextPage } from 'next';
import { RouteEnum } from '../../types';

// import modules
import { fetchBlogPosts, fetchBlogTags } from '../../modules/fetcher';

// import component
import BlogTemplate from '../../components/templates/BlogTemplate';

// define page
const BlogPage: NextPage<{
  blogPosts: { image: string; slug: string; tags: string[]; title: string }[];
  blogTags: { slug: string; title: string }[];
  hrefLang: string;
}> = ({ blogTags, blogPosts, hrefLang }) => (
  <BlogTemplate blogTags={blogTags} blogPosts={blogPosts} hrefLang={hrefLang} />
);

BlogPage.propTypes = {
  blogPosts: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      tags: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
      title: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  blogTags: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  hrefLang: PropTypes.string.isRequired,
};

export const getStaticProps: GetStaticProps = async () => {
  // init vars
  const hrefLang = RouteEnum.WEBSITE_BLOG_EN;
  const locale = 'de';

  // fetch posts
  const blogPostsLang = await fetchBlogPosts({
    sort: { key: 'createdAt', direction: 'desc' },
  });
  const blogPosts = blogPostsLang
    ?.filter((item) => item.locale === locale)
    .map((item) => item.post);

  // fetch blog tags
  const blogTagsLang = await fetchBlogTags();
  const blogTags = blogTagsLang?.filter((item) => item.locale === locale).map((item) => item.tag);

  return { props: { blogPosts, blogTags, hrefLang } };
};

export default BlogPage;
